import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';

@Component({
  selector: 'app-external-denials-audits',
  templateUrl: './external-denials-audits.component.html',
  styleUrls: ['./external-denials-audits.component.scss'],
})
export class ExternalDenialsAuditsComponent implements OnInit {
  public url: any;
  constructor(
    public sanitizer: DomSanitizer,
    private t2templateService: T2ThemeService
  ) {}

  ngOnInit() {
    this.getTokeToProvider();
  }
  private getTokeToProvider() {
    this.t2templateService.getProviderToken().subscribe((resp) => {
      if (resp != undefined && resp != null) {
        const urlRedirect = `${environment.url_webapp}/${resp.value}/billing_v1_providerDenials`;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(urlRedirect);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/external-billing/external-denials-audits/external-denials-audits.component.ts